import logo from './logo.svg';
import './App.css';

function App() {
  // 現在の日付と時刻を取得
  const currentTime = new Date().toLocaleString();
  
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <p>Current time: {currentTime}</p> {/* 日時を表示 */}
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
